import { AlertDialog, AlertDialogContent } from "@/components/ui/alert-dialog";
import { ResetConfirmation } from "./reset/ResetConfirmation";
import { ResetActions } from "./reset/ResetActions";
import { useResetData } from "./reset/useResetData";

interface ResetDataDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ResetDataDialog = ({
  open,
  onOpenChange,
}: ResetDataDialogProps) => {
  const { isLoading, handleReset } = useResetData(() => onOpenChange(false));

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <ResetConfirmation />
        <ResetActions isLoading={isLoading} onConfirm={handleReset} />
      </AlertDialogContent>
    </AlertDialog>
  );
};